export default {
  app: {
    name: 'NomadMate',
  },
  notFound: {
    title: 'Страница не найдена',
    description: 'Страница, которую вы ищете, не существует',
    goBack: 'На главную',
  },
  common: {
    loading: 'Загрузка...',
    noData: 'Нет данных',
    error: 'Произошла ошибка, попробуйте снова',
    retry: 'Повторить',
    authExpired: 'Сессия истекла, войдите снова',
    requestFailed: 'Запрос не удался',
    networkError: 'Ошибка сети, проверьте подключение',
    skipToContent: 'Перейти к основному содержанию',
  },
  nav: {
    dashboard: 'Панель',
    visa: 'Виза',
    cost: 'Расходы',
    timezone: 'Часовой пояс',
    tax: 'Налоги',
    guide: 'Гид',
    login: 'Войти',
  },
  footer: {
    about: 'О нас',
    privacy: 'Конфиденциальность',
    terms: 'Условия',
    copyright: '© 2026 NomadMate',
  },
  index: {
    hero: {
      title: 'Ваша жизнь цифрового кочевника, организована',
      subtitle: 'Универсальная платформа: отслеживание виз, сравнение расходов, координация часовых поясов, налоговое соответствие и городские гиды',
      cta: 'Начать бесплатно',
      learnMore: 'Узнать больше',
    },
    features: {
      title: 'Основные функции',
      visa: { title: 'Отслеживание виз', desc: 'Отслеживайте типы виз, сроки действия и напоминания о продлении' },
      cost: { title: 'Сравнение расходов', desc: 'Сравнивайте стоимость жизни: жильё, питание, транспорт и другое' },
      timezone: { title: 'Управление временем', desc: 'Часы разных поясов и координация встреч между поясами' },
      tax: { title: 'Налоговый помощник', desc: 'Запрос трансграничных налоговых правил и предупреждения о днях пребывания' },
      guide: { title: 'Гид по городам', desc: 'Подробные гиды по мировым направлениям для цифровых кочевников' },
    },
    stats: {
      countries: 'Стран',
      cities: 'Городов',
      languages: 'Языков',
    },
  },
  login: {
    login: 'Войти',
    register: 'Регистрация',
    subtitle: 'Войдите в NomadMate для управления кочевой жизнью',
    registerSubtitle: 'Создайте аккаунт и начните жизнь цифрового кочевника',
    email: 'Электронная почта',
    emailPlaceholder: 'vashe@email.com',
    emailInvalid: 'Введите корректный адрес электронной почты',
    username: 'Имя пользователя',
    usernamePlaceholder: 'Введите имя пользователя',
    password: 'Пароль',
    passwordPlaceholder: '••••••••',
    passwordTooShort: 'Пароль должен содержать минимум 6 символов',
    confirmPassword: 'Подтвердите пароль',
    confirmPasswordPlaceholder: 'Введите пароль ещё раз',
    passwordMismatch: 'Пароли не совпадают',
    loading: 'Вход в систему...',
    error: 'Ошибка входа, попробуйте снова',
    orContinueWith: 'Или продолжите через',
    noAccount: 'Нет аккаунта?',
    hasAccount: 'Уже есть аккаунт?',
  },
  dashboard: {
    welcome: 'С возвращением, {name}',
    subtitle: 'Обзор вашей кочевой жизни',
    stats: {
      activeVisas: 'Активные визы',
      daysUntilExpiry: 'Дней до истечения',
      citiesCompared: 'Сравнено городов',
      timezones: 'Отслеживаемые пояса',
    },
    expiryAlerts: 'Оповещения об истечении виз',
    noAlerts: 'Нет предстоящих оповещений',
    daysLeft: '{days} дней осталось',
    worldClocks: 'Мировые часы',
    quickActions: 'Быстрые действия',
    actions: {
      visa: 'Отслеживание виз',
      cost: 'Сравнение расходов',
      timezone: 'Часовые пояса',
      tax: 'Налоговый помощник',
      guide: 'Гид по городам',
    },
    recentActivity: 'Недавняя активность',
    noActivity: 'Нет недавней активности',
  },
  visa: {
    title: 'Управление визами',
    subtitle: 'Отслеживайте и управляйте визовой информацией',
    searchPlaceholder: 'Поиск по стране...',
    allRegions: 'Все регионы',
    regions: {
      europe: 'Европа',
      asia: 'Азия',
      americas: 'Америка',
      oceania: 'Океания',
    },
    noCountries: 'Страны не найдены',
    requirements: 'Требования',
    documents: 'Необходимые документы',
    track: 'Отслеживать эту визу',
    applyUrl: 'Ссылка на заявку',
    myTracked: 'Мои отслеживаемые визы',
  },
  cost: {
    title: 'Стоимость жизни',
    subtitle: 'Сравнивайте стоимость жизни в разных городах',
    selectCities: 'Выберите города',
    selectHint: 'Выберите 2-4 города для сравнения',
    compare: 'Сравнить',
    selectedCount: 'Выбрано городов: {count}',
    comparison: 'Сравнение',
    category: 'Категория',
    nomadScore: 'Рейтинг кочевника',
    budgetFinder: 'Поиск по бюджету',
    budgetPlaceholder: 'Введите ежемесячный бюджет',
    findCities: 'Найти города',
    aiSuggestion: 'AI-рекомендации скоро',
  },
  timezone: {
    title: 'Управление часовыми поясами',
    subtitle: 'Управляйте расписаниями и встречами в разных поясах',
    addTimezone: 'Добавить часовой пояс',
    noTimezones: 'Нажмите выше, чтобы добавить часовые пояса',
    meetingScheduler: 'Планировщик встреч',
    meetingHint: 'Выберите часовые пояса участников для поиска лучшего времени',
    findMeeting: 'Найти время встречи',
    finding: 'Поиск...',
    bestTime: 'Лучшее время',
    workingOverlap: 'Пересечение рабочих часов',
  },
  tax: {
    title: 'Налоговый помощник',
    subtitle: 'Трансграничный налоговый расчёт и соответствие',
    rules: 'Налоговые правила',
    selectCountry: 'Выберите страну',
    thresholdDays: 'Порог дней пребывания',
    days: 'дней',
    taxRates: 'Налоговые ставки',
    reportingRequirements: 'Требования к отчётности',
    importantDates: 'Важные даты',
    residenceTracker: 'Трекер дней пребывания',
    noResidenceDays: 'Нет записей о днях пребывания',
    riskIndicator: 'Индикатор налогового риска',
    noRiskData: 'Нет данных о рисках',
    countries: {
      portugal: 'Португалия',
      thailand: 'Таиланд',
      spain: 'Испания',
      germany: 'Германия',
      estonia: 'Эстония',
      georgia: 'Грузия',
      croatia: 'Хорватия',
      mexico: 'Мексика',
      colombia: 'Колумбия',
      indonesia: 'Индонезия',
      japan: 'Япония',
      southKorea: 'Южная Корея',
      unitedKingdom: 'Великобритания',
      unitedStates: 'США',
    },
  },
  guide: {
    title: 'Гид по городам',
    subtitle: 'Гиды по мировым направлениям для цифровых кочевников',
    allContinents: 'Все',
    noCities: 'Города не найдены',
    backToList: 'Вернуться к списку',
    internetQuality: 'Качество интернета',
    safetyRating: 'Рейтинг безопасности',
    climate: 'Климат',
    communitySize: 'Размер сообщества',
    coworkingSpaces: 'Коворкинги',
    noCoworking: 'Нет доступных коворкингов',
    day: 'день',
  },
  settings: {
    title: 'Настройки',
    subtitle: 'Управление аккаунтом и предпочтениями',
    profile: 'Профиль',
    username: 'Имя пользователя',
    email: 'Электронная почта',
    saveProfile: 'Сохранить профиль',
    saving: 'Сохранение...',
    language: 'Язык',
    notifications: 'Уведомления',
    visaExpiryNotif: 'Напоминания об истечении виз',
    taxReminderNotif: 'Налоговые напоминания',
    appearance: 'Оформление',
    light: 'Светлое',
    dark: 'Тёмное',
    baseTimezone: 'Основной часовой пояс',
    dangerZone: 'Опасная зона',
    dangerDesc: 'Эти действия необратимы, действуйте с осторожностью',
    deleteAccount: 'Удалить аккаунт',
    confirmDelete: 'Подтвердить удаление аккаунта',
    confirmDeleteDesc: 'Это навсегда удалит ваш аккаунт и все данные. Это действие нельзя отменить.',
    cancel: 'Отмена',
    confirm: 'Удалить',
  },
  about: {
    title: 'О нас',
    subtitle: 'NomadMate - Помощник цифрового кочевника',
    version: 'Версия',
    versionNumber: '1.0.0',
    description: 'NomadMate — помощник для цифровых кочевников: управление визами, сравнение стоимости жизни, управление часовыми поясами, налоговые расчёты и городские гиды для удобной кочевой жизни по всему миру.',
    openSource: 'Благодарности open source',
    openSourceDesc: 'Этот проект создан на основе следующих отличных open source проектов',
    contact: 'Связаться с нами',
    support: 'Техническая поддержка',
    feedback: 'Обратная связь',
    privacyPolicy: 'Политика конфиденциальности',
    terms: 'Условия использования',
  },
}
